var _rect, _polygon, _rect2, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _rect3, _polygon7, _polygon8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPA7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 990 720"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.7.1",
    x: 248.02,
    y: 380,
    width: 90.98,
    height: 117
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.7.2",
    points: "242.81 380 242.81 497 168 497 168 509 93.88 509 93.88 380 242.81 380"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.7.3",
    x: 82,
    y: 181,
    width: 133,
    height: 195
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.7.4",
    points: "219.44 181 339 181 339 340 246 340 246 329 219.44 329 219.44 181"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.7.5",
    points: "344 199 463 199 463 329 437 329 437 340 344 340 344 199"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.7.6",
    points: "467.14 199 587 199 587 340 493.01 340 493.01 329 467.14 329 467.14 199"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.7.7",
    points: "591 199 710 199 710 329 685 329 685 340 591 340 591 199"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.7.8",
    points: "715 211 896 211 896 376 814.16 376 814.16 340 715 340 715 211"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.7.9",
    x: 715,
    y: 379.96,
    width: 193,
    height: 159.04
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.7.10",
    points: "710.09 379.96 710.09 509 590.73 509 590.73 391 617 391 617 379.96 710.09 379.96"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.7.11",
    points: "587 391 587 509 466.91 509 466.91 379.96 561 379.96 561 391 587 391"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyAKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgCiAgICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgCiAgICB2aWV3Qm94PSIwIDAgOTkwIDcyMCIKPgogICAgPHJlY3QgZGF0YS1pZD0iQS43LjEiIHg9IjI0OC4wMiIgeT0iMzgwIiB3aWR0aD0iOTAuOTgiIGhlaWdodD0iMTE3Ii8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjcuMiIgcG9pbnRzPSIyNDIuODEgMzgwIDI0Mi44MSA0OTcgMTY4IDQ5NyAxNjggNTA5IDkzLjg4IDUwOSA5My44OCAzODAgMjQyLjgxIDM4MCIvPgogICAgPHJlY3QgZGF0YS1pZD0iQS43LjMiIHg9IjgyIiB5PSIxODEiIHdpZHRoPSIxMzMiIGhlaWdodD0iMTk1Ii8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjcuNCIgcG9pbnRzPSIyMTkuNDQgMTgxIDMzOSAxODEgMzM5IDM0MCAyNDYgMzQwIDI0NiAzMjkgMjE5LjQ0IDMyOSAyMTkuNDQgMTgxIi8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjcuNSIgcG9pbnRzPSIzNDQgMTk5IDQ2MyAxOTkgNDYzIDMyOSA0MzcgMzI5IDQzNyAzNDAgMzQ0IDM0MCAzNDQgMTk5Ii8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjcuNiIgcG9pbnRzPSI0NjcuMTQgMTk5IDU4NyAxOTkgNTg3IDM0MCA0OTMuMDEgMzQwIDQ5My4wMSAzMjkgNDY3LjE0IDMyOSA0NjcuMTQgMTk5Ii8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjcuNyIgcG9pbnRzPSI1OTEgMTk5IDcxMCAxOTkgNzEwIDMyOSA2ODUgMzI5IDY4NSAzNDAgNTkxIDM0MCA1OTEgMTk5Ii8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjcuOCIgcG9pbnRzPSI3MTUgMjExIDg5NiAyMTEgODk2IDM3NiA4MTQuMTYgMzc2IDgxNC4xNiAzNDAgNzE1IDM0MCA3MTUgMjExIi8+CiAgICA8cmVjdCBkYXRhLWlkPSJBLjcuOSIgeD0iNzE1IiB5PSIzNzkuOTYiIHdpZHRoPSIxOTMiIGhlaWdodD0iMTU5LjA0Ii8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjcuMTAiIHBvaW50cz0iNzEwLjA5IDM3OS45NiA3MTAuMDkgNTA5IDU5MC43MyA1MDkgNTkwLjczIDM5MSA2MTcgMzkxIDYxNyAzNzkuOTYgNzEwLjA5IDM3OS45NiIvPgogICAgPHBvbHlnb24gZGF0YS1pZD0iQS43LjExIiBwb2ludHM9IjU4NyAzOTEgNTg3IDUwOSA0NjYuOTEgNTA5IDQ2Ni45MSAzNzkuOTYgNTYxIDM3OS45NiA1NjEgMzkxIDU4NyAzOTEiLz4KPC9zdmc+";
export { SvgPA7 as ReactComponent };